import React, { useState, useEffect, useRef, useCallback } from "react";
import "./App.css";
import calmSound from "./sound-ambience-sonido-ambiente-56-15570.mp3";
import meditation1 from "./meditations/Méditation 1 - L'ancrage corporel - Revenir au sol .mp3";
import meditation2 from "./meditations/Méditation 2 - La vague émotionnelle - Accueillir et stabiliser.mp3";
import meditation3 from "./meditations/Méditation 3 - Intégration - Se relier à la force intérieure.mp3";
import meditation4 from "./meditations/Méditation 4 - 5.4.3.2.1 Papillon.mp3";
import meditation5 from "./meditations/Méditation 5 - Revenir au calme après une activation émotionnelle.mp3";
import meditation6 from "./meditations/Méditation 6 - La lumière de la résilience - Apaiser et renforcer l'esprit.mp3";
import meditation7 from "./meditations/Méditation 7 - Ancrage dans votre lieu sûr.mp3";
import meditation8 from "./meditations/Méditation 8 - Les 4 éléments - Ancrage et équilibre intérieur.mp3";
function App() {
  const [currentPage, setCurrentPage] = useState("menu");
  const [started, setStarted] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [scale, setScale] = useState(0.6);
  const [breathPhase, setBreathPhase] = useState("Inspirez");
  const [timeLeft, setTimeLeft] = useState(300);
  const [audio] = useState(new Audio(calmSound));
  const [sessionCompleted, setSessionCompleted] = useState(false);
  const [dailySessions, setDailySessions] = useState(0);
  const [showCustomization, setShowCustomization] = useState(true);
  const audioContextRef = useRef(null);
  
  const [bubbleColor, setBubbleColor] = useState("blue");
  const [background, setBackground] = useState("plage");
  const [soundMode, setSoundMode] = useState("musique");

  const [currentMeditation, setCurrentMeditation] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const meditationAudioRef = useRef(null);

  const [isAuthenticated, setIsAuthenticated] = useState(
  localStorage.getItem('vitabulleAuth') === 'true'
);
const ACCESS_CODE = 'PSYCOACH'; // ← Changez ici votre code d'accès

  const meditations = [
  {
    id: 1,
    title: "L'ancrage corporel - Revenir au sol",
    subtitle: "Revenir au sol",
    duration: "6 min 35",
    objective: "Retrouver une sensation de stabilité et de sécurité en vous reconnectant à votre corps et au moment présent.",
    music: "Relaxing par Bensound.com",
    audio: meditation1
  },
  {
    id: 2,
    title: "La vague émotionnelle - Accueillir et stabiliser",
    subtitle: "Accueillir et stabiliser",
    duration: "5 min 27",
    objective: "Accueillir vos émotions comme des vagues qui montent et redescendent naturellement, sans vous laisser submerger.",
    music: "Wave 963Hz - Source : Pixabay Music Licence libre de droits",
    audio: meditation2
  },
  {
    id: 3,
    title: "Intégration - Se relier à la force intérieure",
    subtitle: "Se relier à la force intérieure",
    duration: "7 min 40",
    objective: "Connecter à vos ressources intérieures et renforcer votre sentiment de cohésion et de complétude.",
    music: "The path of meditation - Under the sun music - Pixabay",
    audio: meditation3
  },
  {
    id: 4,
    title: "Le papillon 5-4-3-2-1",
    subtitle: "Revenir dans l'ici et maintenant",
    duration: "8 min 02",
    objective: "Stabilisation sensorielle et retour à la réalité.",
    music: "Soothing meditation - DanaMusic - Pixabay.com",
    audio: meditation4
  },
  {
    id: 5,
    title: "Retour au calme après une activation émotionnelle",
    subtitle: "Après une activation émotionnelle",
    duration: "8 min 06",
    objective: "Ramener le système nerveux à l'équilibre après une forte émotion.",
    music: "Meditation relax (with nature sound) - DanaMusic - Pixabay.com",
    audio: meditation5
  },
  {
    id: 6,
    title: "La lumière de la résilience",
    subtitle: "Apaiser et renforcer l'esprit",
    duration: "8 min 26",
    objective: "Apaiser le système nerveux, stimuler la stabilité émotionnelle et renforcer les ressources intérieures.",
    music: "Meditation Music - Original Soundtrack - Pixabay.com",
    audio: meditation6
  },
  {
    id: 7,
    title: "Ancrage dans votre lieu sûr",
    subtitle: "Lieu de sécurité intérieure",
    duration: "7 min 08",
    objective: "S'ancrer profondément dans son lieu sûr intérieur, mobiliser tous les sens pour renforcer la stabilité et le sentiment de sécurité.",
    music: "Meditation music - Pixabay.com",
    audio: meditation7
  },
  {
    id: 8,
    title: "Les 4 éléments",
    subtitle: "Ancrage et équilibre intérieur",
    duration: "9 min 12",
    objective: "S'ancrer et se recentrer en utilisant la symbolique des éléments, renforcer la stabilité émotionnelle et la présence.",
    music: "Méditation nature morning bilateral - Pixabay.com",
    audio: meditation8
  }
];
  const bubbleColors = {
    blue: {
      gradient: "radial-gradient(circle at 35% 35%, rgba(100, 200, 255, 0.9), rgba(50, 150, 255, 0.7), rgba(30, 100, 200, 0.5))",
      shadow: "0 0 80px rgba(100, 200, 255, 0.6), inset -15px -15px 40px rgba(255, 255, 255, 0.5), inset 15px 15px 40px rgba(30, 100, 200, 0.3), 0 0 120px rgba(50, 150, 255, 0.4)"
    },
    green: {
      gradient: "radial-gradient(circle at 35% 35%, rgba(144, 238, 144, 0.9), rgba(60, 179, 113, 0.7), rgba(34, 139, 34, 0.5))",
      shadow: "0 0 80px rgba(144, 238, 144, 0.6), inset -15px -15px 40px rgba(255, 255, 255, 0.5), inset 15px 15px 40px rgba(34, 139, 34, 0.3), 0 0 120px rgba(60, 179, 113, 0.4)"
    },
    purple: {
      gradient: "radial-gradient(circle at 35% 35%, rgba(221, 160, 221, 0.9), rgba(186, 85, 211, 0.7), rgba(138, 43, 226, 0.5))",
      shadow: "0 0 80px rgba(221, 160, 221, 0.6), inset -15px -15px 40px rgba(255, 255, 255, 0.5), inset 15px 15px 40px rgba(138, 43, 226, 0.3), 0 0 120px rgba(186, 85, 211, 0.4)"
    },
    pink: {
      gradient: "radial-gradient(circle at 35% 35%, rgba(255, 182, 193, 0.9), rgba(255, 105, 180, 0.7), rgba(255, 20, 147, 0.5))",
      shadow: "0 0 80px rgba(255, 182, 193, 0.6), inset -15px -15px 40px rgba(255, 255, 255, 0.5), inset 15px 15px 40px rgba(255, 20, 147, 0.3), 0 0 120px rgba(255, 105, 180, 0.4)"
    },
    yellow: {
      gradient: "radial-gradient(circle at 35% 35%, rgba(255, 255, 150, 0.9), rgba(255, 215, 0, 0.7), rgba(255, 193, 7, 0.5))",
      shadow: "0 0 80px rgba(255, 255, 150, 0.6), inset -15px -15px 40px rgba(255, 255, 255, 0.5), inset 15px 15px 40px rgba(255, 193, 7, 0.3), 0 0 120px rgba(255, 215, 0, 0.4)"
    }
  };

  const backgrounds = {
  plage: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920&h=1080&fit=crop",
  montagne: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&h=1080&fit=crop",
  foret: "https://images.unsplash.com/photo-1448375240586-882707db888b?w=1920&h=1080&fit=crop",
jardin: "https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?w=1920&h=1080&fit=crop",
nuit: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=1920&h=1080&fit=crop"
};

  const initAudioContext = useCallback(() => {
    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioContextRef.current;
  }, []);

  const playBell = useCallback(() => {
    const audioContext = initAudioContext();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.frequency.value = 528;
    oscillator.type = "sine";
    
    gainNode.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.4, audioContext.currentTime + 0.05);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 1.5);
    
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 1.5);
  }, [initAudioContext]);

  const playBreath = useCallback((type) => {
    const audioContext = initAudioContext();
    const bufferSize = audioContext.sampleRate * 1.5;
    const buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate);
    const data = buffer.getChannelData(0);
    
    for (let i = 0; i < bufferSize; i++) {
      data[i] = Math.random() * 2 - 1;
    }
    
    const noise = audioContext.createBufferSource();
    noise.buffer = buffer;
    
    const filter = audioContext.createBiquadFilter();
    filter.type = "bandpass";
    filter.frequency.value = type === "inhale" ? 600 : 300;
    filter.Q.value = 2;
    
    const gainNode = audioContext.createGain();
    
    noise.connect(filter);
    filter.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    gainNode.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.2, audioContext.currentTime + 0.3);
    gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 1.5);
    
    noise.start(audioContext.currentTime);
    noise.stop(audioContext.currentTime + 1.5);
  }, [initAudioContext]);

const handleLogin = (e) => {
  e.preventDefault();
  const input = e.target.code.value;

  // Compare les deux en minuscules
  if (input.toLowerCase() === ACCESS_CODE.toLowerCase()) {
    setIsAuthenticated(true);
    localStorage.setItem('vitabulleAuth', 'true');
  } else {
    alert('Code incorrect. Veuillez réessayer.');
  }
};

  useEffect(() => {
    if (started && !sessionCompleted) {
      initAudioContext();
      
      if (soundMode === "musique") {
        audio.loop = true;
        audio.play().catch(e => console.log("Erreur audio:", e));
      }

      const breathDuration = 5000;
      let isInhaling = true;
      
      const breathCycle = setInterval(() => {
        if (isInhaling) {
          setBreathPhase("Inspirez");
          setScale(1.4);
          if (soundMode === "metronome") {
            playBell();
          } else if (soundMode === "respiration") {
            playBreath("inhale");
          }
        } else {
          setBreathPhase("Expirez");
          setScale(0.6);
          if (soundMode === "metronome") {
            playBell();
          } else if (soundMode === "respiration") {
            playBreath("exhale");
          }
        }
        isInhaling = !isInhaling;
      }, breathDuration);

      const timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            setSessionCompleted(true);
            setDailySessions((prevSessions) => Math.min(prevSessions + 1, 3));
            clearInterval(breathCycle);
            clearInterval(timer);
            audio.pause();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearInterval(breathCycle);
        clearInterval(timer);
        audio.pause();
      };
    }
  }, [started, sessionCompleted, soundMode, audio, playBell, playBreath, initAudioContext]);

  const playMeditation = (meditation) => {
    if (meditationAudioRef.current) {
      meditationAudioRef.current.pause();
    }
    
const newAudio = new Audio(meditation.audio);
    meditationAudioRef.current = newAudio;
    setCurrentMeditation(meditation);
    newAudio.play();
    setIsPlaying(true);
    
    newAudio.onended = () => {
      setIsPlaying(false);
      setCurrentMeditation(null);
    };
  };

  const togglePlayPause = () => {
    console.log("Toggle play/pause clicked");
    if (meditationAudioRef.current) {
      if (isPlaying) {
        meditationAudioRef.current.pause();
        setIsPlaying(false);
      } else {
        meditationAudioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const stopMeditation = () => {
    console.log("Stop clicked");
    if (meditationAudioRef.current) {
      meditationAudioRef.current.pause();
      meditationAudioRef.current.currentTime = 0;
    }
    setIsPlaying(false);
    setCurrentMeditation(null);
  };

  const minutes = Math.floor(timeLeft / 60);
  const seconds = String(timeLeft % 60).padStart(2, "0");

  const resetSession = () => {
    setStarted(false);
    setSessionCompleted(false);
    setTimeLeft(300);
    setScale(0.6);
    setBreathPhase("Inspirez");
    setCurrentPage("menu");
  };

  if (!isAuthenticated) {
  return (
    <div className="intro-screen">
      <div className="intro">
        <div className="intro-card-menu">
          <h1>Vitabulle</h1>
          <h2>Espace réservé aux patients</h2>
          <form onSubmit={handleLogin} style={{marginTop: '30px'}}>
            <input
              type="password"
              name="code"
              placeholder="Entrez votre code d'accès"
              style={{
                padding: '12px 20px',
                fontSize: '16px',
                borderRadius: '8px',
                border: '2px solid #43a047',
                marginBottom: '20px',
                width: '250px'
              }}
              required
            />
            <br/>
            <button
              type="submit"
              style={{
                padding: '12px 30px',
                fontSize: '16px',
                backgroundColor: '#43a047',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              Accéder à Vitabulle
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

  const startNewSession = () => {
    setSessionCompleted(false);
    setTimeLeft(300);
    setScale(0.6);
    setBreathPhase("Inspirez");
  };

  const handleStartCoherence = () => {
    initAudioContext();
    setCurrentPage("coherence");
    setStarted(true);
  };

  if (currentPage === "menu") {
    return (
      <div className="intro-screen">
        <div className="intro">
          <div className="intro-card-menu">
            <h1>Vitabulle</h1>
            <h2>Le pouvoir de la respiration</h2>
            
            {dailySessions > 0 && (
              <div className="medals-display">
                <p className="medals-title">Séances du jour :</p>
                <div className="medals">
                  <span className={dailySessions >= 1 ? "medal active" : "medal"}>🏅</span>
                  <span className={dailySessions >= 2 ? "medal active" : "medal"}>🏅</span>
                  <span className={dailySessions >= 3 ? "medal active" : "medal"}>🏅</span>
                </div>
                {dailySessions < 3 && (
                  <p className="medals-info">Objectif recommandé : 3 séances par jour</p>
                )}
                {dailySessions === 3 && (
                  <p className="medals-complete">🎉 Objectif atteint ! Bravo !</p>
                )}
              </div>
            )}

            <div className="menu-cards">
              <div className="menu-card" onClick={handleStartCoherence}>
                <div className="menu-card-icon">🫁</div>
                <h3>Cohérence cardiaque</h3>
                <p>Pratiquez l'exercice de respiration pour apaiser votre système nerveux en 5 minutes</p>
              </div>

              <div className="menu-card" onClick={() => setCurrentPage("comprendre")}>
                <div className="menu-card-icon">📚</div>
                <h3>Comprendre</h3>
                <p>Découvrez les bases scientifiques et les bienfaits de la cohérence cardiaque</p>
              </div>

              <div className="menu-card" onClick={() => setCurrentPage("stabilite")}>
                <div className="menu-card-icon">🌸</div>
                <h3>Stabilité émotionnelle</h3>
                <p>Accédez à des pratiques guidées pour cultiver votre équilibre intérieur</p>
              </div>

              <div className="menu-card" onClick={() => setCurrentPage("ressources")}>
  <div className="menu-card-icon">📝</div>
  <h3>Blog & Ressources</h3>
  <p>Retrouvez mes articles, outils et ressources pour approfondir votre pratique.</p>
</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (currentPage === "comprendre") {
    return (
      <div className="info-page">
        <div className="info-container">
          <button className="back-btn" onClick={() => setCurrentPage("menu")}>
            ← Retour au menu
          </button>
          
          <h1>Comprendre la cohérence cardiaque</h1>
          
          <div className="info-content">
            <section>
              <h2>🫀 Qu'est-ce que la cohérence cardiaque ?</h2>
              <p>La cohérence cardiaque repose sur un phénomène naturel appelé <strong>arythmie sinusale respiratoire (ASR)</strong> : votre cœur bat plus vite quand vous inspirez, et plus lentement quand vous expirez. C'est normal et c'est même un signe de bonne santé !</p>
              <p>La pratique de la cohérence cardiaque consiste à respirer de façon régulière (5 secondes d'inspiration, 5 secondes d'expiration) pour <strong>synchroniser votre respiration et votre rythme cardiaque</strong>. Cette synchronisation maximise l'amplitude de l'ASR et envoie des signaux d'apaisement à tout votre organisme.</p>
            </section>

            <section>
              <h2>🧬 Comment ça agit sur votre corps ?</h2>
              <p>Votre système nerveux autonome fonctionne avec deux branches :</p>
              <ul>
                <li>Le <strong>système sympathique</strong> : il vous met en mode "action" (accélération cardiaque, tension, vigilance)</li>
                <li>Le <strong>système parasympathique</strong> : il vous met en mode "repos et digestion" (ralentissement cardiaque, détente, récupération)</li>
              </ul>
              <p>Quand vous pratiquez la cohérence cardiaque, vous <strong>stimulez le nerf vague</strong>, qui est le principal nerf du système parasympathique. Ce nerf relie votre cerveau à votre cœur, vos poumons, votre système digestif... En respirant lentement, vous activez ce "frein naturel" qui calme l'ensemble de votre organisme.</p>
              <p>Résultat : votre système nerveux retrouve son <strong>équilibre</strong> entre activation et relaxation.</p>
            </section>

            <section>
              <h2>🧠 Que se passe-t-il dans votre cerveau ?</h2>
              <p>La respiration lente agit directement sur deux zones importantes de votre cerveau :</p>
              <ul>
                <li>Elle <strong>active le cortex préfrontal</strong> (la zone du contrôle et de la réflexion)</li>
                <li>Elle <strong>réduit l'activation de l'amygdale</strong> (la zone des émotions intenses comme la peur et l'anxiété)</li>
              </ul>
              <p>Ce rééquilibrage cérébral explique pourquoi vous vous sentez plus calme, plus clair·e et plus centré·e après quelques minutes de pratique.</p>
            </section>

            <section>
              <h2>✅ Les bienfaits</h2>
              <p>La pratique régulière de la cohérence cardiaque apporte des bénéfices concrets :</p>
              
              <h3>Effets immédiats (durée : 4 à 6 heures)</h3>
              <ul>
                <li>Réduction du stress et de l'anxiété</li>
                <li>Amélioration de la concentration</li>
                <li>Sensation de calme intérieur</li>
                <li>Meilleure clarté mentale</li>
              </ul>

              <h3>Effets à moyen et long terme (avec une pratique régulière)</h3>
              <ul>
                <li>Meilleure gestion émotionnelle</li>
                <li>Amélioration de la qualité du sommeil</li>
                <li>Réduction de la tension artérielle</li>
                <li>Renforcement de la capacité d'adaptation face aux difficultés</li>
              </ul>
            </section>

            <section>
              <h2>📅 Pourquoi 3 séances par jour ?</h2>
              <p>Les effets d'une séance durent environ <strong>4 à 6 heures</strong>. C'est pourquoi pratiquer <strong>3 fois 5 minutes par jour</strong> permet de maintenir cet équilibre tout au long de la journée :</p>
              <ul>
                <li><strong>Matin</strong> : préparer votre système nerveux pour la journée</li>
                <li><strong>Milieu de journée</strong> : maintenir le calme et la concentration</li>
                <li><strong>Fin d'après-midi</strong> : faciliter la transition vers la soirée et favoriser un bon sommeil</li>
              </ul>
              <p>C'est ce qu'on appelle le protocole <strong>365</strong> : <strong>3</strong> fois par jour, <strong>6</strong> respirations par minute, pendant <strong>5</strong> minutes.</p>
            </section>

            <section>
              <h2>🌸 En plus de votre thérapie</h2>
              <p>Il est utile que vous utilisiez la cohérence cardiaque comme <strong>outil d'autorégulation émotionnelle</strong> en complément du travail thérapeutique. Elle vous offre un moyen concret et accessible de :</p>
              <ul>
                <li><strong>Apaiser votre système nerveux</strong> en quelques minutes</li>
                <li><strong>Reprendre le contrôle</strong> face au stress et aux émotions intenses</li>
                <li><strong>Développer votre autonomie</strong> dans la gestion de votre bien-être au quotidien</li>
              </ul>
             x<p>Cette pratique régulière renforce votre capacité naturelle à faire face aux défis de la vie avec plus de sérénité.</p>
            </section>

            <section>
              <h2>🎥 Aller plus loin : De la cohérence cardiaque à la stabilité émotionelle</h2>
              <p>Cette courte vidéo vous explique comment la cohérence cardiaque peut s'articuler avec les pratiques de méditation pour renforcer votre stabilité émotionnelle (voir Menu "Stabilité émotionnelle" pour accèder aux méditations guidées).</p>
              
              <div className="video-container">
                <iframe 
                  width="100%" 
                  height="400" 
                  src="https://www.youtube.com/embed/HVVpa_-pLkE" 
                  title="Cohérence cardiaque et méditation" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen>
                </iframe>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }

  if (currentPage === "stabilite") {
    return (
      <div className="info-page">
        <div className="info-container">
          <button className="back-btn" onClick={() => setCurrentPage("menu")}>
            ← Retour au menu
          </button>
          
          <h1>Stabilité émotionnelle</h1>
          
          <div className="info-content">
            <p className="intro-text meditation-intro">
              Ces méditations guidées d'ancrage et de stabilisation émotionnelle sont inspirées des principes de l'EMDR et visent à soutenir la régulation émotionnelle et la présence.
              <br/><br/>
              <em>Elles ne remplacent en aucun cas une thérapie EMDR ou un accompagnement psychothérapeutique.</em>
            </p>

            {currentMeditation && (
              <div className="current-player">
                <h3>En cours :</h3>
                <div className="player-info">
                  <p className="player-title">{currentMeditation.title}</p>
                  <p className="player-duration">{currentMeditation.duration}</p>
                  <div className="player-controls">
                    <button className="player-btn" onClick={togglePlayPause}>
                      {isPlaying ? "⏸ Pause" : "▶ Lecture"}
                    </button>
                    <button className="player-btn stop" onClick={stopMeditation}>
                      ⏹ Arrêter
                    </button>
                  </div>
                </div>
              </div>
            )}
            
            
            
            <div className="meditations-list">
              {meditations.map((meditation) => (
                <div key={meditation.id} className="meditation-card">
                  <div className="meditation-header">
                    <h3>Méditation {meditation.id}</h3>
                    <span className="meditation-duration">{meditation.duration}</span>
                  </div>
                  <h4 className="meditation-title">{meditation.title}</h4>
                  <p className="meditation-objective"><strong>Objectif :</strong> {meditation.objective}</p>
                  <p className="meditation-music"><strong>Musique :</strong> {meditation.music}</p>
                  <button 
                    className="meditation-play-btn"
                    onClick={() => playMeditation(meditation)}
                    disabled={currentMeditation?.id === meditation.id && isPlaying}
                  >
                    {currentMeditation?.id === meditation.id && isPlaying ? "▶ En cours..." : "▶ Écouter"}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (currentPage === "ressources") {
  return (
    <div className="info-page">
      <div className="info-container">
        <button className="back-btn" onClick={() => setCurrentPage("menu")}>
          ← Retour au menu
        </button>
        
        <h1>Blog & Ressources</h1>
        
        <div className="info-content">
          <section>
            <h2>📝 Mon blog</h2>
            <p>Retrouvez mes articles sur la psychologie, l'EMDR, et le bien-être :</p>
            <button className="resource-link" onClick={() => window.open('https://psycoachaction.com/blog/', '_blank')}>
              Accéder au blog Psy Coach ACTion →
            </button>
          </section>

          <section>
 <h2>🎧 Podcasts inspirants</h2>
<ul>
<li>
<strong>Ipokamp</strong> - Le podcast de psychologie qui explore les mécanismes de l'esprit avec bienveillance et profondeur
<br/>
<a href="https://www.ipokamp.fr" target="_blank" rel="noopener noreferrer" style={{color: '#43a047'}}>→ Écouter</a>
</li>
<li>
<strong>Dingue (RTS)</strong> - Explorer les troubles mentaux et comprendre nos vulnérabilités avec bienveillance
<br/>
<a href="https://www.rts.ch/podcasts-originaux/programmes/dingue/podcast/" target="_blank" rel="noopener noreferrer" style={{color: '#43a047'}}>→ Écouter sur RTS</a>
</li>
<li>
<strong>Émotions de Louie Media</strong> - Explorer et comprendre nos émotions avec Cyrielle Bedu
<br/>
<a href="https://www.louiemedia.com/emotions" target="_blank" rel="noopener noreferrer" style={{color: '#43a047'}}>→ Écouter</a>
</li>
<li>
<strong>Métamorphose</strong> - Éveiller sa conscience et se reconnecter à soi
<br/>
<a href="https://www.metamorphosepodcast.com/" target="_blank" rel="noopener noreferrer" style={{color: '#43a047'}}>→ Écouter</a>
</li>
</ul>
            <h2>🎬 Films thérapeutiques</h2>
            <ul>
              <li>
                <strong>Après coup (2017)</strong> - Un père en état de stress post-traumatique entreprend une psychothérapie bouleversante. Une exploration sensible du processus de guérison.
                <br/>
<a href="https://www.youtube.com/watch?v=wGitWF-enp4" target="_blank" rel="noopener noreferrer" style={{color: '#43a047'}}>→ Voir sur YouTube</a>
</li>
              <li><strong>Good Will Hunting</strong> - L'importance du lien thérapeutique et de la confiance dans le processus de guérison</li>
              <li><strong>Vice-Versa (Inside Out)</strong> - Comprendre le rôle essentiel de toutes nos émotions, même les plus difficiles</li>
            </ul>
          </section>

          <section>
            <h2>📚 Lectures recommandées</h2>
            <ul>
              <li><strong>Le Corps n'oublie rien</strong> - Bessel van der Kolk - La référence sur le trauma et la guérison</li>
              <li><strong>Les liens d'attachement</strong> - Gwenaëlle Persiaux et Yoanna Micoud - Comprendre comment nos premiers liens influencent notre vie</li>
              <li><strong>Les psychotraumatismes</strong> - Gwenaëlle Persiaux et Yoanna Micoud - Guide pour comprendre et accompagner les personnes traumatisées</li>
              <li><strong>Guérir le stress, l'anxiété et la dépression</strong> - David Servan-Schreiber - Approches naturelles et cohérence cardiaque</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

  return (
  <div className="session">
    <div 
      className="background-image" 
      style={{ backgroundImage: `url(${backgrounds[background]})` }}
    ></div>
    <div className="background-overlay"></div>
        
        {sessionCompleted && (
          <div className="completion-modal">
            <div className="completion-content">
              <h2>🎉 Félicitations ! 🎉</h2>
              <p className="completion-message">Vous avez terminé votre séance de cohérence cardiaque !</p>
              <div className="completion-medal">🏅</div>
              <p className="sessions-count">
                {dailySessions === 1 && "1ère séance du jour terminée ! Encore 2 pour atteindre l'objectif."}
                {dailySessions === 2 && "2 séances terminées ! Plus qu'une pour compléter votre objectif quotidien."}
                {dailySessions === 3 && "🌟 INCROYABLE ! Vous avez complété vos 3 séances quotidiennes ! 🌟"}
              </p>
              <div className="completion-buttons">
                <button className="completion-btn primary" onClick={startNewSession}>
                  Nouvelle séance
                </button>
                <button className="completion-btn secondary" onClick={resetSession}>
                  Retour au menu
                </button>
              </div>
            </div>
          </div>
        )}
        
        <div className="session-content">
          <div className="header-section">
            <h1 className="header-top">Le pouvoir de la respiration</h1>
            
            <button 
              className="toggle-customization-btn" 
              onClick={() => setShowCustomization(!showCustomization)}
            >
              {showCustomization ? "✕ Masquer" : "⚙️ Personnaliser"}
            </button>
          </div>
          
          {showCustomization && (
            <div className="customization-menu">
              <div className="custom-section">
                <label>Couleur :</label>
                <div className="color-picker">
                  <button className={`color-btn blue ${bubbleColor === 'blue' ? 'active' : ''}`} onClick={() => setBubbleColor('blue')}></button>
                  <button className={`color-btn green ${bubbleColor === 'green' ? 'active' : ''}`} onClick={() => setBubbleColor('green')}></button>
                  <button className={`color-btn purple ${bubbleColor === 'purple' ? 'active' : ''}`} onClick={() => setBubbleColor('purple')}></button>
                  <button className={`color-btn pink ${bubbleColor === 'pink' ? 'active' : ''}`} onClick={() => setBubbleColor('pink')}></button>
                  <button className={`color-btn yellow ${bubbleColor === 'yellow' ? 'active' : ''}`} onClick={() => setBubbleColor('yellow')}></button>
                </div>
              </div>
              
              <div className="custom-section">
                <label>Ambiance :</label>
                <div className="background-picker">
                  <button className={background === 'plage' ? 'active' : ''} onClick={() => setBackground('plage')}>🌅</button>
                  <button className={background === 'montagne' ? 'active' : ''} onClick={() => setBackground('montagne')}>❄️</button>
                  <button className={background === 'foret' ? 'active' : ''} onClick={() => setBackground('foret')}>🌿</button>
                  <button className={background === 'jardin' ? 'active' : ''} onClick={() => setBackground('jardin')}>🌸</button>
                  <button className={background === 'nuit' ? 'active' : ''} onClick={() => setBackground('nuit')}>🌌</button>
                </div>
              </div>

              <div className="custom-section">
                <label>Son :</label>
                <div className="sound-picker">
                  <button className={soundMode === 'musique' ? 'active' : ''} onClick={() => setSoundMode('musique')}>🎵</button>
                  <button className={soundMode === 'metronome' ? 'active' : ''} onClick={() => setSoundMode('metronome')}>🔔</button>
                  <button className={soundMode === 'respiration' ? 'active' : ''} onClick={() => setSoundMode('respiration')}>🌬️</button>
                  <button className={soundMode === 'silence' ? 'active' : ''} onClick={() => setSoundMode('silence')}>🔇</button>
                </div>
              </div>
            </div>
          )}

          <div className="bubble-container">
            <div 
              className="bubble" 
              style={{ 
                transform: `scale(${scale})`,
                background: bubbleColors[bubbleColor].gradient,
                boxShadow: bubbleColors[bubbleColor].shadow
              }}
            >
              <div className="breath-text-inside">{breathPhase}</div>
            </div>
          </div>

          <div className="bottom-controls">
            <button className="option-btn" onClick={() => setShowTimer((prev) => !prev)}>
              {showTimer ? "⏱️ Masquer le chrono" : "⏱️ Afficher le chrono"}
            </button>
            
            {showTimer && (
              <div className="timer-inline">
                {minutes}:{seconds}
              </div>
            )}
            
            <button className="option-btn" onClick={resetSession}>
              🏠 Retour au menu
            </button>
          </div>
        </div>

        {/* ⭐⭐⭐ BOUTON FEEDBACK — AJOUT GLOBAL ⭐⭐⭐ */}
        <div 
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000
          }}
        >
          <a
            href="https://forms.gle/HsmNzcEDBxjn7ziM9"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#43a047',
              color: 'white',
              padding: '12px 20px',
              borderRadius: '25px',
              textDecoration: 'none',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            💬 Feedback
          </a>
        </div>

  </div>
);
}

export default App;